module.exports = __webpack_public_path__ + "static/media/video.98a4322f.webm";